import { h, defineComponent, SetupContext } from 'vue';
import { ValidationError } from '@/entities/validation';
// @ts-ignore
import { BDatetimepicker } from 'buefy/dist/esm/datetimepicker';
import { Field, FieldProps } from './Field';
import { SetterCallback } from '@/ui/types';
import { Button } from '@/ui/components/Button';
import { t } from '@/ui/i18n/i18n';

export interface DateTimeFieldProps {
  name: string;
  label: string;
  value: Date | null;
  required: boolean;
  placeholder: string;
  errors: ValidationError[];
  disabled: boolean;
  clearable: boolean;
  mobileNative?: boolean;
  position?: 'is-top-right' | 'is-top-left' | 'is-bottom-left';
  minDatetime?: Date | null;
  locale?: string;
  hideLabel?: boolean;
  datePickerClass?: string;
  horizontalTimePicker?: boolean;
}

export const DateTimeField = defineComponent<DateTimeFieldProps>({
  name: 'DateTimeField',
  props: [
    'name', 'label', 'value',
    'required', 'placeholder', 'errors',
    'disabled', 'clearable', 'mobileNative',
    'position', 'minDatetime', 'locale', 'hideLabel', 'datePickerClass', 'horizontalTimePicker',
  ],
  setup(props, context: SetupContext) {
    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors,
        disabled: props.disabled,
        hideLabel: props.hideLabel,
      };
      return h(Field, { props: fieldProps }, [
        h(BDatetimepicker, {
          class: props.datePickerClass,
          props: {
            value: props.value,
            horizontalTimePicker: props.horizontalTimePicker ?? true,
            icon: 'calendar',
            placeholder: props.placeholder,
            disabled: props.disabled,
            datepicker: {
              yearsRange: [-3, 3],
            },
            position: props.position,
            mobileNative: props.mobileNative === undefined ? true : props.mobileNative,
            minDatetime: props.minDatetime,
            locale: props.locale,
          },
          on: {
            input: (newValue: string) => {
              context.emit('input', newValue);
            },
          },
        }, [
          props.clearable && props.value !== null
            ? h(Button, {
              props: { type: 'is-light' },
              on: {
                click: () => {
                  context.emit('input', null);
                },
              },
              slot: 'right',
            }, t('form.clear-date'))
            : null,
        ]),
      ]);
    };
  },
});

export function dateTimeField(props: DateTimeFieldProps, input: SetterCallback<Date>) {
  return h(DateTimeField, {
    props,
    on: { input },
  });
}
